
        <div class="modal-header">
            <h4 class="modal-title">{{ record ? 'Modifica' : 'Nuovo' }} brand</h4>
        </div>
        <div class="modal-body">
            <form [formGroup]="form" (submit)="submitHandler($event)">
                <div class="row form-group">
                    <label class="col-form-label">Nome</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="name" [ngClass]="{'is-invalid': errors?.name }">
                        <span *ngIf="errors?.name"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.name[0] }}
                </span>
                    </div>
                </div>
            </form>

        </div>
        <div class="modal-footer">
            <button class="btn btn-default" (click)="modal.dismiss()">Chiudi</button>
            <button class="btn btn-primary" [disabled]="form.invalid" (click)="submitHandler($event)">Salva</button>
        </div>
    